var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.routerBack },
        }),
      ]),
      _vm.statusView == "All"
        ? _c(
            "el-row",
            {
              staticStyle: { "margin-top": "15px", "margin-left": "15px" },
              attrs: { type: "flex", align: "middle" },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.addData },
                },
                [_vm._v("新增")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "danger" },
                  on: { click: _vm.delData },
                },
                [_vm._v("删除")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-table",
        {
          ref: "plxTable",
          staticStyle: { "margin-top": "15px" },
          attrs: {
            border: "",
            data: _vm.tableData,
            "max-height": "500",
            "highlight-current-row": "",
          },
          on: { "selection-change": _vm.selectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", type: "selection", width: "80" },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "版本",
              "min-width": "140",
              prop: "headerVersion",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "所属大类",
              "min-width": "100",
              prop: "parentName",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "评分项编码",
              "min-width": "100",
              prop: "scoreItemCode",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "评分项名称",
              "min-width": "120",
              prop: "name",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.onDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.name))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "Description",
              "min-width": "120",
              prop: "description",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "SPM",
              "min-width": "80",
              prop: "version",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "最大分值",
              "min-width": "120",
              prop: "maxValue",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "Wt.1",
              "min-width": "120",
              prop: "wt1",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "Wt.2",
              "min-width": "120",
              prop: "wt2",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "评分标准说明1",
              "min-width": "120",
              prop: "standard1",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "评分标准说明2",
              "min-width": "120",
              prop: "standard2",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "评分标准说明3",
              "min-width": "120",
              prop: "standard3",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "评分标准说明4",
              "min-width": "120",
              prop: "standard4",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "评分标准说明5",
              "min-width": "120",
              prop: "standard5",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "排序",
              "min-width": "120",
              prop: "orderNo",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "更新人",
              "min-width": "120",
              prop: "updateByName",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "更新时间",
              "min-width": "120",
              prop: "updateDate",
              "show-overflow-tooltip": "",
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            label: "维护评分项",
            visible: _vm.showDetailDialog,
            "append-to-body": "",
            width: "50%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDetailDialog = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _vm.showDetailDialog
            ? _c("detailDialog", {
                attrs: {
                  formData: _vm.formData,
                  temId: _vm.temId,
                  detailId: _vm.detailId,
                },
                on: { close: _vm.closeDialog },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }